import React, { PureComponent, Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Button, {
  AnimatedView,
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableCol,
  Pagination,
  Alert
} from "../../../../components"; 
import { history } from "../../../../redux/store/configureStore";
import { appConfig } from "../../../../config";
import * as qs from "query-string";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";

import { browserHistory } from "react-router";
import isEmpty from "lodash.isempty";

let categoryItems;

class edit extends PureComponent {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      catID: "",
      catType: "",
      catName: "",
      type: "",
      status: "",
      weight: "1",
      parentId: "0",
      catList: [],
      catDetail: [],
      parentCategories: [],
      msgType: null,
      msg: null,
      french_catName: '',
      multi_lang: 'no',
      weight: '',
    };

    this.handlesOnNameChange.bind(this);
  }

  componentWillMount() {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));

    if(siteData){
      if(siteData.multi_lang){
        this.setState({
          multi_lang: siteData.multi_lang
        });
      }
    }
    
    const {
      actions: { getCategory }
    } = this.props;
    getCategory();

    const id = location.hash.split("/");
    if (id) {
      const {
        actions: { getCategoryDetail }
      } = this.props;
      getCategoryDetail(id[id.length - 1]);
    }
  }

  componentWillReceiveProps(nextProps) {
    const id = location.hash.split("/");
    this.setState({
      catDetail: nextProps.catDetail ? nextProps.catDetail.data : {}
    });

    if (this.props.catDetail !== nextProps.catDetail) {
      this.setState({
        catName: nextProps.catDetail.data.catName,
        catType: nextProps.catDetail.data.catType,
        type: nextProps.catDetail.data.type,
        status: nextProps.catDetail.data.status,
        weight: nextProps.catDetail.data.weight,
        parentId: nextProps.catDetail.data.parentID,
        french_catName: nextProps.catDetail.data.french_catName,
        catID: id[id.length - 1],
        msgType: "",
        msg: ""
      });
    }

    if (
      this.props.catDetail !== nextProps.catDetail &&
      nextProps.catList &&
      nextProps.catDetail.data.parentID != 0
    ) {
      let categories = [];
      let pId = nextProps.catDetail.data.parentId;
      if (pId) {
        const {
          actions: { getCategoryDetail }
        } = this.props;
        getCategoryDetail(pId);
      }
      if (pId !== 0) {
        this.setState({ parentCategories: nextProps.catList.data.data });
      }
    }

    if (typeof nextProps.error.error != "undefined") {
      this.setState({ msgType: "error", msg: nextProps.error.error });
    }
  }

  static propTypes = {
    actions: PropTypes.shape({
      addCategory: PropTypes.func,
      getCategory: PropTypes.func
    })
  };

  handleChange = (event: SyntheticEvent<>) => {
    if (event) {
      event.preventDefault();
      this.setState({ parentId: event.target.value });
    }
  };

  handlesOnNameChange = (event: SyntheticEvent<>) => {
    if (event) {
      event.preventDefault();
      this.setState({ catName: event.target.value.trim() });
    }
  };

  handlesOnCatChange = (event: SyntheticEvent<>) => {
    if (event) {
      event.preventDefault();
      this.setState({ catType: event.target.value });
    }
  };

  handlesOntypeChange = (event: SyntheticEvent<>) => {
    if (event) {
      event.preventDefault();
      this.setState({ type: event.target.value });
      if (event.target.value == "Category" || event.target.value == "") {
        document.getElementById("parentId").disabled = true;
      } else if (event.target.value == "Sub-category") {
        let categories = [];
        this.props.catList.data.data.map(el =>
          categories.push(
            "<option value=" +
              el.cat_id +
              " key=" +
              el.catID +
              ">" +
              el.catName +
              "</option>"
          )
        );
        $("#parentId").append(categories);
        document.getElementById("parentId").disabled = false;
      }
    }
  };

  handlesOnstatusChange = (event: SyntheticEvent<>) => {
    if (event) {
      event.preventDefault();
      this.setState({ status: event.target.value });
    }
  };

  handlesOnClick = async (event: SyntheticEvent<>) => {
    if (event) {
      event.preventDefault();
    }

    const { history } = this.props;
    const {
      catID,
      catType,
      catName,
      type,
      status,
      weight,
      parentId,
      french_catName
    } = this.state;

    const category = {
      catID: catID,
      catType: catType,
      catName: catName,
      type: type,
      status: status,
      weight: weight,
      parentId: parentId,
      french_catName: french_catName,
    };

    try {
      const {
        actions: { updateCategory }
      } = this.props;
      updateCategory(category);

      this.context.router.history.push({ pathname: "/categories/editcategories/" + catID }); // back to Home
    } catch (error) {}
  };

  renderAlert() {
    if (this.state.msgType && this.state.msg) {
      let msgClass =
        this.state.msgType == "error"
          ? "alert alert-danger"
          : "alert alert-" + this.state.msgType;
      return (
        <div className={msgClass}>
          <strong>{this.state.msgType.toUpperCase()} :</strong> {this.state.msg}
        </div>
      );
    }
  }

  render() {
    const headerTitle = "Update Category";
    let defaultDisabled;
    this.state.parentId == "494a49a366fa637c27aa5d165a2ded45"
      ? (defaultDisabled = true)
      : (defaultDisabled = false);

    if (this.state.parentCategories) {
      categoryItems = this.state.parentCategories.map((catObject, index) => (
        <option key={index} value={catObject.catID}>
          {catObject.catName}
        </option>
      ));
    }

    return (
      <div className="col-xs-12">
        <div className="row mt-5">
          <div className="col-xs-12">
            <Link replace to={"/categories/"} className="pull-right btn btn-success">
              <b>Back</b>
            </Link>
          </div>
          <div className="col-xs-12">
            <Panel hasTitle={true} title={headerTitle}>
              <form role="form">
                {this.renderAlert()}

                <div className="form-group">
                  <label htmlFor="name">Name</label>
                  <input
                    type="text"
                    className="form-control"
                    id="catName"
                    name="catName"
                    placeholder="Enter name"
                    value={
                      this.state.catName == ""
                        ? this.state.catDetail.catName
                        : this.state.catName
                    }
                    onChange={this.handlesOnNameChange}
                  />
                </div>
                {(this.state.multi_lang == "yes") &&
                  <div className="form-group">
                    <label htmlFor="name">Name (Canadian French)</label>
                    <input
                      type="text"
                      className="form-control"
                      id="french_catName"
                      name="french_catName"
                      placeholder="Enter name"
                      value={
                        this.state.french_catName
                      }
                      onChange={this.handlesOnNameChange}
                    />
                  </div>
                }

                <div className="form-group">
                  <label htmlFor="catType">Category Type: </label>
                  <select
                    value={
                      this.state.catType == ""
                        ? this.state.catDetail.catType
                        : this.state.catType
                    }
                    name="catType"
                    className="form-control"
                    onChange={this.handlesOnCatChange}
                  >
                    <option value="">Select Category Type</option>
                    <option value="local">Local</option>
                    <option value="shopping">Shopping</option>
                    <option value="parentcategory">Parent Category</option>
                    <option value="gift">Gift Voucher</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>Type:</label>
                  <select
                    value={
                      this.state.type == ""
                        ? this.state.catDetail.type
                        : this.state.type
                    }
                    name="type"
                    className="form-control"
                    onChange={this.handlesOntypeChange.bind(this)}
                  >
                    <option value="">Select Type</option>
                    <option value="Category">Category</option>
                    <option value="Sub-category">Sub Category</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>Category Name:</label>
                  <select
                    value={
                      this.state.parentId == 0
                        ? this.state.catDetail.parentId
                        : this.state.parentId
                    }
                    disabled={defaultDisabled}
                    id="parentId"
                    name="parentId"
                    className="form-control"
                    onChange={this.handleChange.bind(this)}
                  >
                    <option value="">Select Parent Category</option>
                    {categoryItems}
                  </select>
                </div>

                <div className="form-group">
                  <label>Active:</label>
                  <select
                    name="status"
                    value={
                      this.state.status == ""
                        ? this.state.catDetail.status
                        : this.state.status
                    }
                    className="form-control"
                    onChange={this.handlesOnstatusChange.bind(this)}
                  >
                    <option value="">Select Status</option>
                    <option value="Active">Yes</option>
                    <option value="Inactive">No</option>
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="name">Weight</label>
                  <input
                    type="text"
                    className="form-control"
                    id="weight"
                    name="weight"
                    placeholder="Weight"
                    value={
                      this.state.catName == ""
                        ? this.state.catDetail.weight
                        : this.state.weight
                    }
                    onChange={this.handlesOnNameChange}
                  />
                </div>

                <button
                  type="submit"
                  className="btn btn-info"
                  onClick={this.handlesOnClick}
                >
                  Update Category
                </button>
              </form>
            </Panel>
          </div>
        </div>
      </div>
    );
  }
}

export default edit;



// WEBPACK FOOTER //
// ./src/app/views/admin/categories/editcategories/edit.js